import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

interface HydrateLocalStorageProviderProps extends React.PropsWithChildren {}

const HydrateLocalStorageProvider: React.FC<
  HydrateLocalStorageProviderProps
> = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      dispatch({ type: 'LOAD_FROM_LOCALSTORAGE' });
    }
  }, [dispatch]);

  return <>{children}</>;
};

export default HydrateLocalStorageProvider;
